import { render, staticRenderFns } from "./MainLayoutDrawer.vue?vue&type=template&id=507369b6&"
import script from "./MainLayoutDrawer.vue?vue&type=script&lang=js&"
export * from "./MainLayoutDrawer.vue?vue&type=script&lang=js&"
import style0 from "./MainLayoutDrawer.vue?vue&type=style&index=0&id=507369b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDrawer,QList});
